import type { OrderExternalStatusDto } from "@/api/dtos";
import type { ExternalStatus } from "@/api/order/_models/Order";

/** DTO → domain for one system's reported status, at order or line level; nulls become undefined. */
export const toExternalStatusFromOrderExternalStatusDto = (
  dto: OrderExternalStatusDto,
): ExternalStatus => {
  return {
    id: dto.id,
    system: dto.system,
    status: dto.status ?? undefined,
    metadata: dto.metadata ?? {},
    statusObservedAt: dto.statusObservedAt ?? undefined,
    lastSyncedAt: dto.lastSyncedAt ?? undefined,
    locationId: dto.locationId ?? undefined,
    locationName: dto.locationName ?? undefined,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
